const knowledgebase = {
    init: function() {
    const kb_mobile_buttons = document.querySelectorAll(".kb-archive__filter-item--mob");
        kb_mobile_buttons.forEach((kbmobbutton) => {
            kbmobbutton.addEventListener('click',function(){
                var offset = 100; // Adjust the offset value as needed
                var targetPosition = kbmobbutton.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            });
        });
    }
}

export default knowledgebase ;